const addAccordionListeners = () => {
    document.addEventListener("click", function(e) {
        const accordionToggle = e.target.closest(".js-accordionToggle");
        if(accordionToggle) {
            e.preventDefault();
            const panel = accordionToggle.closest(".c-accordion__item").querySelector(".c-accordion__panel");
            accordionToggle.classList.toggle("is-active");
            slideTogglePanel(panel);
        }
    });
};

const slideTogglePanel = (element) => {
    if (window.getComputedStyle(element).display === "none") {
        element.style.display = "block";
        const height = `${element.clientHeight}px`;
        element.style.height = "auto";
        setTimeout(() => {
            element.style.height = height;
        }, 0);
    } else {
        element.style.height = `${element.clientHeight}px`;
        setTimeout(() => {
            element.style.height = "0px";
        }, 0);
        setTimeout(() => {
            element.style.display = "none";
            element.style.height = "";
        }, 200);
    }
};

addAccordionListeners();